import {
  DEEPLINK,
  PARAMS,
  MODALS
} from '../actions';

const INIT_STATE = {
	deepLink: (() => {
    let url = window.location.href
    let d = null
    if (url.indexOf('deepLink') > -1) {
      d = url.split("=")
      d = d[1] 
      d = JSON.parse(atob(d))
      return d
    }
	})(),
  params: null,
  modals: [],
  preview: null
};

export default (state = INIT_STATE, action) => {
	switch (action.type) {
		case DEEPLINK:
      return { ...state, deepLink:action.payload};
    case PARAMS:
      return { ...state, params:action.payload};
    case MODALS:
        return { ...state, modals:action.payload};
		default: return { ...state };
	}
}